export const getJakartaTime = (date: Date | string): string => {
  return new Date(date).toLocaleString('en-US', {
    timeZone: 'Asia/Jakarta',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
};

export const getJakartaISOString = (): string => {
  const now = new Date();
  // Add 7 hours to get Jakarta time
  const jakartaTime = new Date(now.getTime() + (7 * 60 * 60 * 1000));
  return jakartaTime.toISOString();
};
